import { NgModule } from '@angular/core';
import { CamelToSentenceCase } from './pipes/camel-to-sentence-case.pipe';
import { dateFormatPipe } from './pipes/date-format-pipe/date-format-pipe';
import { DateLocalPipe } from './pipes/date-format-pipe/date-local';
import { DatexPipe } from './pipes/date-format-pipe/datex';
import { PostcodePipe } from './pipes/postcode.pipe';
import { WrapTextPipe } from './pipes/wrap-text.pipe';
import { HasFlagsPipe } from './pipes/has-flags.pipe';
import { MetresToMilesPipe } from './pipes/metres-to-miles.pipe';
import { HourBandPipe } from './pipes/hour-band.pipe';
import { CronHumanizePipe } from './pipes/cron-humanize.pipe';
import { MinutesToHoursPipe } from './pipes/minutes-to-hours.pipe';
import { MinutesToHoursMinutesPipe } from './pipes/minutes-to-hours-minutes.pipe';
import { TruncateTimeStringPipe } from './pipes/date-format-pipe/truncate-time-string';
import { DurationStringToMinutesPipe } from './pipes/duration-string-to-minutes';
import { HourDecimalToHHMMPipe } from './pipes/hour-decimal-to-HHMM.pipe';
import { OrdinalNumberPipe } from './pipes/ordinal-number.pipe';
import { BankersRoundPipe } from './pipes/bankers-round.pipe';

const pipes = [
  dateFormatPipe,
  DatexPipe,
  DateLocalPipe,
  TruncateTimeStringPipe,
  WrapTextPipe,
  PostcodePipe,
  MetresToMilesPipe,
  HourBandPipe,
  HourDecimalToHHMMPipe,
  HasFlagsPipe,
  CamelToSentenceCase,
  CronHumanizePipe,
  MinutesToHoursPipe,
  MinutesToHoursMinutesPipe,
  BankersRoundPipe,
  DurationStringToMinutesPipe,
  OrdinalNumberPipe,
];

@NgModule({
  declarations: [...pipes],
  exports: [...pipes],
})
export class VmePipesModule {}
